import { useUnit } from 'effector-react';
import { $menuState } from '@nx-frontend/shared/store/feature-menu-tree';
import { MenuItem, MenuType } from '@nx-frontend/shared/types';

type GetPagePortalMenuItemResult =
  | (MenuItem & { parentItem?: MenuItem | null; portalDomain?: string; portalId?: string })
  | null;

interface UseGetPagePortalMenuItemParams {
  portalDomain: string;
  portalId: string;
}

export interface GetPortalMenuItemParams {
  globalId?: string;
  portalPageId?: string;
}

export function useGetPagePortalMenuItem(params: UseGetPagePortalMenuItemParams) {
  const [menuState] = useUnit([$menuState]);
  const { portalDomain, portalId } = params;

  return ({ globalId, portalPageId }: GetPortalMenuItemParams): GetPagePortalMenuItemResult => {
    let menuItem: GetPagePortalMenuItemResult = null;
    let parentItem;
    [MenuType.PORTAL_SIDEBAR, MenuType.PORTAL_TOPBAR, MenuType.PORTAL_FOOTER].forEach((menuType) => {
      const item = Object.values(menuState[menuType].entities).find(
        ({ targetId, pageId }) => targetId === globalId || (pageId && pageId === portalPageId)
      );
      if (item) {
        menuItem = item;
        if (item.parentId) {
          parentItem = menuState[menuType].entities[item.parentId];
        }
      }
    });

    if (menuItem) {
      return {
        ...(menuItem as MenuItem),
        parentItem,
        portalDomain,
        portalId,
      };
    }

    return null;
  };
}
